/* House of KAHŌ — lightweight scroll reveals. Adds .is-visible to .kaho-reveal elements as they enter the viewport.
   Respects prefers-reduced-motion and works with Horizon's section rendering and theme editor reloads. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer;

  const reveal = (root = document) => {
    const items = root.querySelectorAll('.kaho-reveal:not(.is-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    observer ??= new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal());
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
